<template>
  <div class="feedback">
    <div class="mbx">
      <Breadcrumb :path="path"></Breadcrumb>
    </div>
    <div class="fl"></div>
    <div class="tabs">
      <!-- <div class="Badge1">55</div>
      <div class="Badge2">55</div>
      <div class="Badge3">55</div>
      <div class="Badge4">55</div>
      <div class="Badge5">55</div> -->
      <a-locale-provider :locale="zh_CN">
        <!-- {{ status + 1 }} -->
        <a-tabs :activeKey="status ? status + 1 : 1" @change="callback">
          <a-tab-pane
            :tab="item"
            v-for="(item, index) in tabTitle"
            :key="index + 1"
          >
            <div class="select">
              <!-- <div class="select-status">
              <span>状态</span>
              <a-select
                v-model="status"
                @change="changeSelect"
                style="width: 133px; height: 100%"
                :options="optionsStatus"
              >
              </a-select>
            </div> -->
              <div class="select-type">
                <span>问题类型</span>
                <a-select
                  v-model="tpye"
                  @change="changeSelect"
                  style="width: 133px; height: 100%"
                  :options="optionsType"
                >
                </a-select>
              </div>
              <div class="select-id">
                <span>问题/主题</span>
                <a-input
                  v-model="id"
                  placeholder="请输入主题关键词"
                  style="width: 267px; height: 36px"
                />
              </div>
              <div class="select-button" @click.stop="query">查询</div>
            </div>
            <div class="Table">
              <a-table
                :columns="columns"
                :data-source="tableData"
                bordered
                :pagination="false"
              >
                <template slot="feedback_type" slot-scope="text">
                  <div
                    :style="{ color: text == '匿名' ? '#333333' : '#0586FB' }"
                  >
                    {{ text }}
                  </div>
                </template>
                <template slot="operation" slot-scope="text, record">
                  <div class="TableButton" @click="goDetail(text, record)">
                    详情
                  </div>
                </template>
              </a-table>
              <div class="Table-sx">
                <div class="Table-sx-page">
                  显示第 {{ pageNumber * (current - 1) + 1 }} 到第
                  {{
                    current * pageNumber > total ? total : current * pageNumber
                  }}
                  条记录，总共
                  {{ total }}
                  条记录每页显示
                  <a-select
                    style="width: 60px"
                    @change="selectChange"
                    v-model="pageNumber"
                  >
                    <a-select-option value="10"> 10 </a-select-option>
                    <a-select-option value="20"> 20 </a-select-option>
                    <a-select-option value="30"> 30 </a-select-option>
                  </a-select>
                  条记录
                </div>
                <!-- 分页器 -->
                <a-pagination
                  show-quick-jumper
                  v-model="current"
                  :pageSize="Number(pageNumber)"
                  :total="Number(total)"
                  @change="paginationChange"
                />
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-locale-provider>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { $get_feedback_list } from "@/api";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");
export default {
  data() {
    return {
      zh_CN,
      // 表格 表头数据
      columns: [
        {
          title: "问题ID",
          dataIndex: "id",
          width: 97,
          align: "center",
        },
        {
          title: "主题",
          dataIndex: "title",
          width: 197,
          ellipsis: true,
          align: "center",
        },
        {
          title: "反馈方式",
          dataIndex: "feedback_type",
          width: 89,
          align: "center",
          scopedSlots: { customRender: "feedback_type" },
        },
        {
          title: "状态",
          dataIndex: "status",
          width: 84,
          align: "center",
        },
        {
          title: "发起时间",
          dataIndex: "create_time_text",
          width: 170,
          align: "center",
        },
        {
          title: "问题类型",
          dataIndex: "data_type",
          width: 112,
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: 123,
          scopedSlots: { customRender: "operation" },
          align: "center",
        },
      ],
      tableData: [], // 表格数据
      status: "", // 状态
      tabTitle: ["全部", "已受理", "处理中", "已办结", "已评价"],
      // 状态的下拉菜单数据
      optionsStatus: [
        { label: "全部", value: "" },
        { label: "已受理", value: "1" },
        { label: "处理中", value: "2" },
        { label: "已办结", value: "3" },
        { label: "已评价", value: "4" },
      ],
      tpye: "", // 问题类型
      // 问题类型的下拉菜单数据
      optionsType: [
        { label: "全部", value: "" },
        { label: "合理化建议", value: "1" },
        { label: "投诉举报", value: "2" },
        { label: "表彰表扬", value: "3" },
      ],
      id: "", // 问题/流程编号(搜索框结果)
      total: 150, // 数据总数
      pageNumber: 10, // 每页显示的数据数量
      current: 1, // 分页器的当前页数
    };
  },
  async mounted() {
    this.current = this.$route.query.current;
    this.status = this.$route.query.status;
    this.tpye = this.$route.query.tpye || "";
    this.id = this.$route.query.value;
    this.query();
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          if (document.documentElement.clientWidth < 767) {
            this.$router.push({ name: "feedbacks" });
          }
        });
      })();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  computed: {
    path() {
      let arr = [
        { name: "我的", names: "feedback" },
        { name: "我的问题反馈", names: "feedback" },
      ];
      return arr;
    },
  },
  components: {
    Breadcrumb,
  },
  methods: {
    // 切换tabs标签栏的回调
    callback(key) {
      if (key - 1) {
        this.status = key - 1;
      } else {
        this.status = "";
      }
      this.query();
    },
    // 切换 状态/问题类型
    changeSelect() {
      this.query();
    },
    // 点击查询按钮 获取数据
    async query() {
      try {
        let params = {
          page: this.current,
          rows: this.pageNumber,
          status: this.status,
          data_type: this.tpye,
          key_word: this.id,
          order_by: "1",
        };
        // console.log(params);
        let res = await $get_feedback_list(params);
        this.tableData = res.data.data;
        let feedback_type = {
          1: "实名",
          2: "匿名",
        };
        let status = {
          1: "已受理",
          2: "处理中",
          3: "已办结",
          4: "已评价",
        };
        let data_type = {
          1: "合理化建议",
          2: "投诉举报",
          3: "表彰表扬",
        };
        this.tableData.forEach((item) => {
          item.feedback_type = feedback_type[item.feedback_type];
          item.status = status[item.status];
          item.data_type = data_type[item.data_type];
          item.key = item.id;
        });
        this.total = res.data.total;
        this.pageNumber = res.data.per_page;
        this.current = res.data.current_page;
      } catch (error) {}
    },
    // 点击详情按钮
    goDetail(text, record) {
      console.log(this.status, this.tpye, this.id);
      let name = {
        合理化建议: "suggestionDetail",
        投诉举报: "complaintDetail",
        表彰表扬: "commendDetail",
      };
      this.$router.push({
        name: name[record.data_type],
        query: {
          id: record.id,
          current: this.current,
          status: this.status,
          tpye: this.tpye,
          value: this.id,
        },
      });
    },
    // 改变每页显示的数据数量
    selectChange(value) {
      this.pageNumber = value;
      this.query();
    },
    // 分页器 页码改变的回调
    paginationChange(page, pageSize) {
      this.current = page;
      this.query();
    },
  },
};
</script>

<style lang="less" scoped>
.feedback {
  padding-bottom: 100px;

  .mbx {
    padding-top: 30px;
    padding-left: 37px;
    margin-bottom: 21px;
  }

  .fl {
    width: 98%;
    height: 1px;
    background: #e9e9e9;
    margin: 0 auto;
    margin-bottom: 10px;
  }

  .tabs {
    position: relative;
    // padding: 0 22px;
    padding-right: 0;

    /deep/.ant-tabs-ink-bar {
      background-color: #e60012;
      width: 40px !important;
      left: 14px;
    }

    /deep/.ant-tabs-bar {
      padding-left: 20px;
    }

    /deep/.ant-tabs-tab {
      position: relative;
    }

    .select {
      margin-top: 23px;
      padding-left: 37px;
    }

    .Badge1 {
      background: #f06c77;
      border-radius: 8px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding: 1px 5px;
      position: absolute;
      top: 0;
      left: 6.5%;
    }

    .Badge2 {
      background: #f06c77;
      border-radius: 8px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding: 1px 5px;
      position: absolute;
      top: 0%;
      left: 16.5%;
    }

    .Badge3 {
      background: #f06c77;
      border-radius: 8px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding: 1px 5px;
      position: absolute;
      top: 0%;
      left: 26.5%;
    }

    .Badge4 {
      background: #f06c77;
      border-radius: 8px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding: 1px 5px;
      position: absolute;
      top: 0%;
      left: 36.5%;
    }

    .Badge5 {
      background: #f06c77;
      border-radius: 8px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding: 1px 5px;
      position: absolute;
      top: 0%;
      left: 46.5%;
    }

    .select {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-right: 11px;
      }

      .select-status,
      .select-type {
        margin-right: 25px;
      }

      .select-id {
        display: flex;
        align-items: center;
        margin-right: 9px;
      }

      .select-button {
        cursor: pointer;
        width: 106px;
        height: 36px;
        background: #e60012;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .Table {
      cursor: pointer;

      .TableButton {
        width: 97px;
        height: 35px;
        background: #333333;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .TableButton:hover {
        width: 97px;
        height: 35px;
        background: #e60012;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .Table-sx {
        margin-left: 16px;
        margin-top: 24px;
        margin-right: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // /deep/.ant-pagination-prev {
        //   margin-right: 0;
        //   border-radius: 0;
        // }
        // /deep/.ant-pagination-prev,
        // .ant-pagination-next,
        // .ant-pagination-jump-prev,
        // .ant-pagination-jump-next {
        //   // width: 45px;
        //   border-radius: 0;
        // }
        // /deep/.ant-pagination-item {
        //   background: #fafafa;
        //   margin-right: 0;
        //   border-radius: 0;
        // }
        // /deep/.ant-pagination-item-active {
        //   background: #2c3e50;
        //   border-color: #d9d9d9;
        // }
        // /deep/.ant-pagination-item-active a {
        //   color: #ffffff !important;
        // }
        // /deep/ .ant-pagination-item:hover {
        //   border-color: #2c3e50 !important;
        // }
      }
    }
  }
}

::v-deep {
  .ant-tabs-nav .ant-tabs-tab-active,
  .ant-tabs-nav .ant-tabs-tab:hover {
    color: #333333 !important;
  }
}
</style>